<template>
  <div class="templatecontent">
    <!-- <cube-scroll
      ref="scroll"
      direction="horizontal">
      <div class="flex">
        <div @click="useTemplate(item)" class="resume-template" v-for="(item,index) in recommendTemplate.download" :key="index + 'cd'">
          <img class="resume-icon" :src="item.imgSrc" alt="">
        </div>
      </div>
     
    </cube-scroll> -->
    <div style="overflow: auto">
      <div class="flex resume-template-body">
        <div class="resume-template" :class="{'resume-template-active' : index == currentIndex}" @click="useTemplate(item, index)" v-for="(item,index) in recommendTemplate.download" :key="index + 'cd'">
          <div class="resume-template-overflow">
            <img class="resume-icon" :src="item.imgSrc" alt="">
            <div v-show="index == currentIndex" class="resume-label">当前模板</div>
            <img v-if="index !== 0" class="vipimg" :src="index == currentIndex ? 'https://files.wondercv.com/PC/editor/VIPtag.png' : 'https://files.wondercv.com/APP/editor/APP_VIP.png'" alt="">
          </div>
        </div>
      </div> 
    </div>
    
  </div>
</template>

<script>
import recommendTemplate from "../../assets/json/recommend-template-style"
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
  name:'resume-template',
  data(){
   return {
     recommendTemplate,
     currentIndex: 0,
     copyFormatData: null, // 还原样式使用
     copyShowattrname: ''
   }
  },
  created() {
    console.log('执行了');
    this.copyFormatData = JSON.parse(JSON.stringify(this.cv.format_info)) 
    this.copyShowattrname = this.profiles.show_attr_name
  },
  computed:{
	  ...mapState('cv', [ 'cv', 'profiles', 'works']),
  },
  methods: {
    ...mapActions('cv', [ 'updateCvDetail', 'updateProfileData' ]),
    async useTemplate(item, index) {
      if(index == this.currentIndex) return
      let { token } = this.$route.params
      this.currentIndex = index
      let temp = JSON.parse(JSON.stringify(item))
      delete temp.imgSrc
      let profilePayload = {
				show_attr_name: index == 0 ? this.copyShowattrname : temp.show_attr_name
			}
      delete temp.show_attr_name
      let payload = {
        format_info: index == 0 ? this.copyFormatData : temp,
        operation_type: "update_format_info"
      }
      this.updateProfileData({ token, payload: profilePayload })
      await this.updateCvDetail({ token, payload })
      this.$emit('change', 'change')
    }
  }
}
</script>

<style scoped lang="scss">
  .templatecontent{
    // display: flex;
    overflow: auto;
    width: 100vw;
    padding: 0px 13px;
    // margin-top: 15px;
  }
  .resume-template-body{
    padding-top: 15px;
    .resume-template {
      width: 97px;
      height: 134px;
      background: #fff;
      margin-right: 16px;
      border-radius: 4px;
      position: relative;
      box-sizing: border-box;
      
      flex-shrink: 0;
      .resume-template-overflow{
        width: 90px;
        height: 130px;
        overflow: hidden;
      }
      .vipimg{ 
        width: 26px;
        height: 14px;
        position: absolute;
        top: -7px;
        right: -10px;
      }
      .resume-icon{
        width: 97px;
        height: 134px;
        object-fit: contain;    
      }
      .resume-label{
        position: absolute;
        bottom: 9px;
        left: 50%;
        transform: translateX(-50%);
        width: 71px;
        height: 23px;
        background: #4183FF;
        border-radius: 4px;
        font-weight: 500;
        font-size: 12px;
        text-align: center;
        line-height: 23px;
        color: #fff;
      }
    }
    .resume-template-active{
      border: 2px solid #4183FF;
    }
  }

  .horizontal-scroll-list-wrap{
      .cube-scroll-content{
        display: inline-block;
      }
      .list-wrapper{
        min-width: 100vw;
        display: flex;
      }   
      .list-item{
        display: inline-block
      }
    
  }
 

</style>
